/* eslint-disable arrow-body-style */
import { css } from '@emotion/react';
import PropTypes from 'prop-types';
import { Icon, Box } from '@mui/material';
import styled from '@emotion/styled';
import isPropValid from '@emotion/is-prop-valid';
import { ReactComponent as TwitterLogo } from './twitter-logo.svg';

const StyledIcon = styled(Icon, {
  shouldForwardProp: (prop) => isPropValid(prop) && prop !== 'isRtlLang',
})`
  &.fa {
    font-size: 25px;
  }
  ${({ isRtlLang }) => {
    if (isRtlLang) {
      return css`margin-left: 12px;`;
    }
    return css`margin-right: 12px;`;
  }}
`;

const StyledTwitterIcon = styled(TwitterLogo, {
  shouldForwardProp: (prop) => isPropValid(prop) && prop !== 'isRtlLang',
})`
  padding: 0 !important;
  margin: 0 !important;
  ${({ isRtlLang }) => {
    if (isRtlLang) {
      return css`margin-left: 12px;`;
    }
    return css`margin-right: 12px;`;
  }}
`;

/**
 * Renders an <AudienceIcon /> component.
 * @param {object} props
 * @param {string} props.color
 * @param {function} props.setColor
 * @param {string} props.type
 * @param {string} props.labelText
 * @returns {React.Component}
 */

export const AudienceIcon = ({
  name, className, isRtlLang, iconColor, ...restProps
}) => {
  return name === 'twitter'
    ? (
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        sx={{
          margin: 0,
          padding: 0,
          height: '36px',
          width: '36px',
        }}
      >
        <StyledTwitterIcon
          isRtlLang={isRtlLang}
          fill={iconColor}
          {...restProps}
        />
      </Box>
    ) : (
      <StyledIcon
        isRtlLang={isRtlLang}
        className={`fa fa-${name}${className && ` ${className}`}`}
        {...restProps}
      />
    );
};

AudienceIcon.propTypes = {
  name: PropTypes.string.isRequired,
  className: PropTypes.string,
  isRtlLang: PropTypes.bool,
  iconColor: PropTypes.string,
};

AudienceIcon.defaultProps = {
  isRtlLang: false,
  className: '',
};
